module.exports = __webpack_public_path__ + "img/img-box-services-banner-right.75eee6eb.png";